import React from "react";
import AppBar from "../components/commons/AppBar";
import Footer from "../components/commons/Footer";
import useStyles from "../styles/privateLayoutStyle";

const PrivateLayout = (props) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {props.showToolBar !== false && <AppBar />}
      <div className={classes.content}>
      {props.children}
      </div>
      {!props.hideFooter && <Footer /> }
    </div>
  );
};

export default PrivateLayout;
